import Vue from 'vue'
import App from './App.vue'
import { store } from '@/store.js'
import './user.js'
import router from './router.js'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

Vue.use(Antd)

store.dispatch("fetchUserInfo");
store.commit("$user/fetchUserInfo");

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
